import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=288119df"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports